import { ToggleButton } from 'vue-js-toggle-button';
import SectorService from '../../services/Sector.js';
import Helper from '../../Helper.js';
import EditorJquery from './EditorJquery.js';
import RadialProgressBar from 'vue-radial-progress';
import moment from 'moment';

if($('#component-article-editor').length){
    var app = new Vue({
        el: '#component-article-editor',
        data: {
            article:{
                title:'',
                subtitle:'',
                content:'',
                article_status_slug:'draft',
                image_location_file:'',
                image_location:'https://'+awsUrl+'/article/Article/MUj76axJNrRrtZjT3QrRqfwCyUif3nO9p3fgtPh8.jpg',
                author_id:currentUserId,
                articleId:articleId,
                sectors:[],
            },
            loading:true,
            sidebar:true,
            createdModal: true,
            justCreated: false,
            completedSteps: 0,
            totalSteps: 0,
            uploaderErrors:[],
            sectors:[],
            employees:['1-10','11-50','51-500','501+'],
            radialColour:'#5B45E0',
            radialWidth:5,
            radialInnerColor:'#E0E0E0',
            loadingMessage:'Loading Article Editor',
            currentUserId: currentUserId,
            Helper: Helper,
            EditorJquery: EditorJquery,
            awsUrl: awsUrl,
            showUploadMedia: false,
            dataImages: [],
            targetId: '',
            imageMedia: false
        },
        methods: {
            getArticle(id){
                axios.get('/api/v1/article/'+id)
                .then((response) =>  {
                    this.article = response.data;
                    this.postLoad();
                })
                .catch((error) =>  {
                    this.errorHandler(error);
                })
            },
            saveArticle(status, applying = false){
                if(this.completedSteps != this.totalSteps){
                    this.$toasted.error("You must complete all fields before submitting your article");
                    return false;
                }
                var form =  document.getElementById('editor-sidebar');
                var formData = new FormData(form);
                formData = this.appendFields(formData);
                formData.append('article_status_slug', status);

                if (!this.article.id && !this.article.image_location_file || this.imageMedia === true) {
                    formData.append('image_location', this.article.image_location.replace("https://" + this.awsUrl + "/", ""));
                    this.imageMedia = false;
                } else if (this.article.image_location_file) {
                    formData.append('image_location', this.article.image_location_file);
                }

                if(this.article.id){
                    this.loading = true;
                    this.loadingMessage = 'Saving Article';

                    axios.post('/api/v1/article/'+this.article.id, formData)
                    .then((response) =>  {

                        if (status === 'publish') {
                            location.replace("/under-review/article");
                            return;
                        }

                        this.article = response.data;

                        this.postLoad();

                        this.$toasted.success('Your Article has been Saved.');
                    })
                    .catch((error) =>  {
                        this.errorHandler(error);
                    });
                }else{
                    this.loading = true;
                    this.loadingMessage = 'Creating Article';

                    axios.post('/api/v1/article', formData)
                    .then((response) =>  {
                        if (status === 'publish') {
                            location.replace("/under-review/article");
                            return;
                        }

                        window.location.replace("/article/edit/"+response.data.id+"?justCreated=true");
                    })
                    .catch((error) =>  {
                        this.errorHandler(error);
                    });
                }
            },
            appendFields(formData) {
                formData.append('author_id', this.article.author_id);
                formData.append('content', this.article.content);
                formData.append('sectors', this.article.sectors);
                formData.append('h-captcha-response', document.querySelector('textarea[name="h-captcha-response"]').value);
                return formData;
            },
            previewImage(fileBlob, file) {
                if (fileBlob && file) {
                    this.article.image_location = fileBlob;
                    this.article.image_location_file = file;
                    this.showUploadMedia = false;
                }
            },
            addhttp(url) {
                if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
                    url = "http://" + url;
                }
                return url;
            },
            postLoad() {
                this.$nextTick(function () {
                    this.loading = false;
                    EditorJquery.jqueryHelpers();
                });
            },
            stepsCalculation(){
                let article = this.article;
                this.completedSteps = 0;

                article.title ? this.completedSteps++ : null; 
                article.subtitle ? this.completedSteps++ : null; 
                article.content ? this.completedSteps++ : null; 

                this.totalSteps = 3;
            },
            errorHandler(error){
                if (error.response) {
                    if (typeof error.response.data === 'string') {
                        this.$toasted.error(error.response.data);
                    } else {
                        this.$toasted.error(error.response.data.message);
                    }
                }
                this.loading = false;
            },
            justCreatedCheck(){
                if(window.location.href.indexOf('justCreated') != -1){
                    this.justCreated = true;
                }else{
                    this.justCreated = false;
                }
            },
            getTime(time){
                var testDateUtc = moment.utc(time);
                var localDate = testDateUtc.local();
                return localDate.format('LLL');
            },
            uploadMedia() {
                this.getUploadedMedia();
                this.targetId = 'image';
                this.showUploadMedia = true;
            },
            getUploadedMedia() {
                axios.get('/api/v1/get-uploaded-media')
                    .then((response) => {
                        if (response.data.hasOwnProperty('uploads')) {
                            this.dataImages = response.data.uploads;
                        }
                    })
                    .catch((error) => {
                        this.errorHandler(error);
                    })
            },
            onSelectImage(data) {
                this.article.image_location = data.src;
                this.imageMedia = true;
                this.showUploadMedia = false;
            },
            selectMethod(result, files) {
                if (result == 'EXTENSION_ERROR') {
                    this.$toasted.error('The selected files contain invalid extensions.');
                    return;
                } else if (result == 'FILE_SIZE_ERROR') {
                    this.$toasted.error('The selected files size exceeded limit.');
                    return;
                }
                if (files && files[0]) {
                    let file = files[0], vm = this, img = new Image();
                    img.onload = function () {
                        if (this.width > 3000 || this.height > 3000) {
                            vm.$toasted.error('The selected image dimensions exceeded limit (3000*3000).');
                        } else {
                            vm.previewImage(img.src, file);
                        }
                    }
                    img.src = URL.createObjectURL(file);
                }
            }
        },
        mounted () {
            SectorService.getSectors().then(data => {
                this.sectors = data;
            });

            this.stepsCalculation();

            if(articleId){
                this.getArticle(articleId);
                this.justCreatedCheck();
                this.cardView = false;
            }else{
                this.postLoad();
            }
        },
        updated: function () {
        },
        components: {
            'ToggleButton': ToggleButton,
            'SectorService': SectorService,
            'RadialProgressBar': RadialProgressBar
        },
        watch: {
            article: {
                handler(val){
                    this.stepsCalculation();
                },
                deep: true
            }
        }
    });
}